var BookapiInsuranceFactory = /** @class */ (function () {
    function BookapiInsuranceFactory() {
    }
    BookapiInsuranceFactory.createBookapiInsurance = function (currentInsuranceData, currentInsuranceKey) {
        return {
            key: currentInsuranceData.hasOwnProperty('key') ? currentInsuranceData.key : '',
            InfoURL: currentInsuranceData.hasOwnProperty('InfoURL') ? currentInsuranceData.InfoURL : '',
            coverage: currentInsuranceData.hasOwnProperty('coverage') ? currentInsuranceData.coverage : '',
            coverageList: currentInsuranceData.hasOwnProperty('coverageList') ? currentInsuranceData.coverageList : [],
            familie: currentInsuranceData.hasOwnProperty('familie') ? currentInsuranceData.familie : '',
            name: currentInsuranceData.hasOwnProperty('name') ? currentInsuranceData.name : '',
            name_short: currentInsuranceData.hasOwnProperty('name_short') ? currentInsuranceData.name_short : '',
            preis: currentInsuranceData.hasOwnProperty('preis') ? currentInsuranceData.preis : '',
            type: currentInsuranceData.hasOwnProperty('type') ? currentInsuranceData.type : ''
        };
    };
    BookapiInsuranceFactory.createArrayOfInsurances = function (currentPaxType) {
        var arrayOfInsurances = [];
        for (var currentInsuranceKey in currentPaxType) {
            if (currentPaxType.hasOwnProperty(currentInsuranceKey)) {
                arrayOfInsurances.push(BookapiInsuranceFactory.createBookapiInsurance(currentPaxType[currentInsuranceKey], currentInsuranceKey));
            }
        }
        return arrayOfInsurances;
    };
    BookapiInsuranceFactory.createMapOfArraysOfInsurances = function (arrays) {
        var newMap = new Map();
        for (var currentArrayKey in arrays) {
            if (arrays.hasOwnProperty(currentArrayKey)) {
                newMap.set(parseInt(currentArrayKey), BookapiInsuranceFactory.createArrayOfInsurances(arrays[currentArrayKey]));
            }
        }
        return newMap;
    };
    return BookapiInsuranceFactory;
}());
export { BookapiInsuranceFactory };
